import {ViewType} from "./view-type"
import {PROJECT_LIST_CONFIG} from "../../../views/list/@config"
import {PROJECT_TABLE_CONFIG} from "../../../views/table/@config"
import {PROJECT_BOARD_CONFIG} from "../../../views/board/@config"
import {PROJECT_GANTT_CONFIG} from "../../../views/gantt/@config"
import {PROJECT_INFO_CONFIG} from "./configs/project/project-info"
import {PROJECT_CALENDAR_CONFIG} from "../../../views/calendar/@config"
import {PROJECT_FILES_CONFIG} from "./configs/project/project-files"
import {PROJECT_ACTIVITY_CONFIG} from "../../../views/activity/@config"
import {PROJECT_WORKLOAD_CONFIG} from "../../../views/workload/@config"
import {PROJECT_DOCS_CONFIG} from "./configs/project/project-docs"
import {PROJECT_MEETINGS_CONFIG} from "./configs/project/project-meeting"
import {PROJECT_EXPENSES_CONFIG} from "../../../views/expenses/@config"
import {PROJECT_DISCUSSION_CONFIG} from "./configs/project/project-discussion"
import {PROJECT_GOALS_CONFIG} from "./configs/project/project-goals"
import {PROJECT_PAGE_CONFIG} from "./configs/project/project-page"
import {PROJECT_DASHBOARD_CONFIG} from "./configs/project/project-dashboard"
import {PROJECT_REQUEST_FORMS_CONFIG} from "./configs/project/project-request-forms"
import {MY_RECENT_CONFIG} from "../../../model2/view/personal-view/views/my-recent"
import {MY_TASKS_LIST_CONFIG} from "../../../model2/view/personal-view/views/my-tasks-list"
import {MY_WORK_WORKLOAD_CONFIG} from "../../../model2/view/personal-view/views/my-work-workload"
import {MY_WORK_CALENDAR_CONFIG} from "../../../model2/view/personal-view/views/my-work-calendar"
import {MY_MEETINGS_CONFIG} from "../../../model2/view/personal-view/views/my-meetings"
import {MY_TIME_CONFIG} from "../../../model2/view/personal-view/views/my-time"
import {MY_WORK_CONFIG} from "../../../model2/view/personal-view/views/my-work"
import {NOTIFICATIONS_CONFIG} from "../../../model2/view/personal-view/views/notifications"
import {MY_NOTES_CONFIG} from "../../../model2/view/personal-view/views/my-notes"
import {MY_DOCUMENTS_CONFIG} from "../../../model2/view/personal-view/views/my-documents"
import {MY_GOALS_CONFIG} from "../../../model2/view/personal-view/views/my-goals"
import {MY_ATTENDANCE_CONFIG} from "../../../model2/view/personal-view/views/my-attendance"
import {CUSTOM_VIEW_TASKS_TABLE_CONFIG} from "./configs/custom/custom-view-tasks-table"
import {CUSTOM_VIEW_PROJECTS_TABLE_CONFIG} from "./configs/custom/custom-view-projects-table"
import {CUSTOM_VIEW_ACTIVITY_CONFIG} from "./configs/custom/custom-view-activity"
import {CUSTOM_VIEW_DOCUMENTS_CONFIG} from "./configs/custom/custom-view-documents"
import {CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG} from "../../../views/events-summary/@config"
import {CUSTOM_VIEW_WHATS_DONE_CONFIG} from "../../../views/whats-done/@config"
import {PORTFOLIO_SUMMARY_CONFIG} from "./configs/portfolio/portfolio-summary"
import {PORTFOLIO_LIST_CONFIG} from "./configs/portfolio/portfolio-list"
import {PORTFOLIO_TABLE_CONFIG} from "./configs/portfolio/portfolio-table"
import {PORTFOLIO_BOARD_CONFIG} from "./configs/portfolio/portfolio-board"
import {PORTFOLIO_GANTT_CONFIG} from "./configs/portfolio/portfolio-gantt"
import {PORTFOLIO_INFO_CONFIG} from "./configs/portfolio/portfolio-info"
import {PORTFOLIO_CALENDAR_CONFIG} from "./configs/portfolio/portfolio-calendar"
import {PORTFOLIO_WORKLOAD_CONFIG} from "./configs/portfolio/portfolio-workload"
import {RESOURCE_PLANNING_CONFIG} from "./configs/resource-planning"
import {PROJECT_LINK_CONFIG} from "./configs/project/project-link"
import {PROJECT_EMBED_CONFIG} from "./configs/project/project-embed"
import {PROJECT_NO_VIEWS} from "./configs/project/project-no-views"
import {CUSTOM_VIEW_EXPENSES_CONFIG} from "../../../views/expenses/@config-custom";
import {PROJECT_REPORTS_CONFIG} from "./configs/project/project-reports"
import {CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG} from "./configs/custom/custom-view-external-data-glist"
import {CUSTOM_VIEW_ACTION_REQUIRED_CONFIG} from "../../../views/action-required/@config";
import {CUSTOM_VIEW_PRIORITIES_CONFIG} from "../../../views/priorities/@config";
import {CUSTOM_VIEW_TASKS_BY_USER_CONFIG} from "../../../views/tasks-by-user/@config";
import {CUSTOM_VIEW_PASTDUE_CONFIG} from "../../../views/pastdue/@config";
import {PROJECTS_PROJECTS_LIST_CONFIG} from "../../../views/projects-list/@config";
import {PROJECTS_PORTFOLIO_CONFIG} from "../../../views/portfolio/@config";
import {CUSTOM_VIEW_DASHBOARD_CONFIG} from "../../../views/dashboard/@config";
import {PROJECT_SUMMARY_CONFIG} from "./configs/project/project-summary"
import {PROJECT_TABLE_MAP_CONFIG} from "./configs/dual-mode/project-map";
import {PROJECT_TIMELINE_CONFIG} from "./configs/project-timeline"
import {PROJECT_WHITEBOARD_CONFIG} from "./configs/project/project-whiteboard";
import {PROJECT_EVERYTHING} from "./configs/project/workspace-everything"
import {PROJECT_EVENTS_SUMMARY_CONFIG} from "./configs/project/events-summary";
import {PROJECT_TODOS_CONFIG} from "./configs/project/project-todos";

export type ViewTypeSystemConfig = {
    name            : string    // system name
    menuName?       : string    // default name for ProjectView or custom Views...

    icon            : string    // base icon ie. i5-icon
    iconSvg?        : string
    image?          : string
    url?            : string
    stringId?       : ID        // menu id (is used to identify curMenuId in top panel)
    customViewName? : string    // default name for custom view
    description?    : string
    singleton?      : boolean   // if true only one instance of the view is allowed (which is wrong)
    inheritance?    : boolean   // if true view can be inherited by subfolders (applies to project views only)
    proOnly?        : boolean   // pro restriction check is required (is used in quick-add and menu-new-view)
    canDelete?      : boolean   // restrict deletion (is used in navigation_hintButtonCustomView and CustomViewInfoAccessManager)

    hasTemplates?   : boolean
    isSingleton?    : boolean
    canBeInProject? : boolean   // can view be added in structure for project
}

export enum ViewAccess {
    PRIVATE     = 0,
    SHARED      = 1
}

export const MY_WORK_VIEWS =  [
        ViewType.MY_RECENT,
        ViewType.MY_TASKS_LIST,
        ViewType.MY_WORK_WORKLOAD,
        ViewType.MY_WORK_CALENDAR,
        ViewType.MY_MEETINGS,
        ViewType.MY_TIME,
        ViewType.MY_NOTES,
        ViewType.MY_DOCUMENTS,
        ViewType.MY_GOALS,
        ViewType.MY_ATTENDANCE
    ] // ViewType.MY_WORK, ViewType.NOTIFICATIONS

export const PROJECTS_VIEWS = [
        ViewType.PROJECTS_PORTFOLIO,
        ViewType.PROJECTS_PROJECTS_LIST,
        ViewType.PORTFOLIO_SUMMARY
    ] //ViewType.MY_WORK, ViewType.NOTIFICATIONS

export const VIEWS_SORT_POSITIONS = [
    ViewType.PROJECT_DISCUSSION,
    ViewType.PROJECT_LIST,
    ViewType.PROJECT_TABLE,
    ViewType.PROJECT_BOARD,
    ViewType.PROJECT_CALENDAR,
    ViewType.PROJECT_GANTT,
    ViewType.PROJECT_WORKLOAD,
    ViewType.PROJECT_DASHBOARD,
    ViewType.PROJECT_FILES,
    ViewType.PROJECT_DOCS,
    ViewType.PROJECT_REQUEST_FORMS,
    ViewType.PROJECT_MEETINGS,
    ViewType.PROJECT_GOALS,
    ViewType.PROJECT_PAGE,
    ViewType.PROJECT_WHITEBOARD,
    ViewType.PROJECT_LINK,
    ViewType.PROJECT_EMBED,
    ViewType.PROJECT_ACTIVITY,
    ViewType.PROJECT_EXPENSES,
    ViewType.PROJECT_INFO,
    ViewType.PROJECT_NO_VIEWS,
    ViewType.PROJECT_REPORTS,
]

// ids used only in modules (locally) and shared views (saved in parameters)
// used in settings & access only?
export const ALL_CUSTOM_VIEWS = [
    ViewType.PROJECT_LIST,
    ViewType.PROJECT_TABLE,
    ViewType.PROJECT_BOARD,
    ViewType.PROJECT_CALENDAR,
    ViewType.PROJECT_GANTT,
    ViewType.PROJECT_WORKLOAD,
    ViewType.PROJECT_TIMELINE,
    ViewType.CUSTOM_VIEW_WHATS_DONE,
    ViewType.CUSTOM_VIEW_ACTION_REQUIRED,
    ViewType.PROJECTS_PROJECTS_LIST,
    ViewType.PROJECTS_PORTFOLIO,
    ViewType.CUSTOM_VIEW_TASKS_BY_USER,
    ViewType.CUSTOM_VIEW_PASTDUE,
    ViewType.CUSTOM_VIEW_PRIORITIES,
    ViewType.CUSTOM_VIEW_EVENTS_SUMMARY,
    ViewType.CUSTOM_VIEW_CUSTOM_ENTITY_GLIST,
    ViewType.PROJECT_ACTIVITY,
    ViewType.MY_RECENT,
    ViewType.MY_TASKS_LIST,
    ViewType.MY_WORK_WORKLOAD,
    ViewType.MY_WORK_CALENDAR,
    ViewType.MY_MEETINGS,
    ViewType.MY_TIME,
    ViewType.MY_NOTES,
    ViewType.MY_DOCUMENTS,
    // ViewType.CUSTOM_VIEW_DOCUMENTS,
    ViewType.CUSTOM_VIEW_DASHBOARD,
    ViewType.MY_GOALS,
    ViewType.MY_ATTENDANCE,
    ViewType.CUSTOM_VIEW_EXPENSES
]

export const ViewTypeConfigs : { [key in ViewType]?: ViewTypeSystemConfig } = {
    [ViewType.PROJECT_LIST]                     : PROJECT_LIST_CONFIG,
    [ViewType.PROJECT_TABLE]                    : PROJECT_TABLE_CONFIG,
    [ViewType.PROJECT_BOARD]                    : PROJECT_BOARD_CONFIG,
    [ViewType.PROJECT_GANTT]                    : PROJECT_GANTT_CONFIG,
    [ViewType.PROJECT_INFO]                     : PROJECT_INFO_CONFIG,
    [ViewType.PROJECT_CALENDAR]                 : PROJECT_CALENDAR_CONFIG,
    [ViewType.PROJECT_EVENTS_SUMMARY]           : PROJECT_EVENTS_SUMMARY_CONFIG,
    [ViewType.PROJECT_FILES]                    : PROJECT_FILES_CONFIG,
    [ViewType.PROJECT_ACTIVITY]                 : PROJECT_ACTIVITY_CONFIG,
    [ViewType.PROJECT_WORKLOAD]                 : PROJECT_WORKLOAD_CONFIG,
    [ViewType.PROJECT_TIMELINE]                 : PROJECT_TIMELINE_CONFIG,
    [ViewType.PROJECT_DOCS]                     : PROJECT_DOCS_CONFIG,
    [ViewType.PROJECT_MEETINGS]                 : PROJECT_MEETINGS_CONFIG,
    [ViewType.PROJECT_EXPENSES]                 : PROJECT_EXPENSES_CONFIG,
    [ViewType.PROJECT_DISCUSSION]               : PROJECT_DISCUSSION_CONFIG,
    [ViewType.PROJECT_GOALS]                    : PROJECT_GOALS_CONFIG,
    [ViewType.PROJECT_PAGE]                     : PROJECT_PAGE_CONFIG,
    [ViewType.PROJECT_WHITEBOARD]               : PROJECT_WHITEBOARD_CONFIG,
    [ViewType.PROJECT_LINK]                     : PROJECT_LINK_CONFIG,
    [ViewType.PROJECT_EMBED]                    : PROJECT_EMBED_CONFIG,
    [ViewType.PROJECT_DASHBOARD]                : PROJECT_DASHBOARD_CONFIG,
    [ViewType.PROJECT_REQUEST_FORMS]            : PROJECT_REQUEST_FORMS_CONFIG,
    [ViewType.PROJECTS_PROJECTS_LIST]           : PROJECTS_PROJECTS_LIST_CONFIG,
    [ViewType.PROJECT_NO_VIEWS]                 : PROJECT_NO_VIEWS,
    [ViewType.PROJECT_EVERYTHING]               : PROJECT_EVERYTHING,
    [ViewType.PROJECT_REPORTS]                  : PROJECT_REPORTS_CONFIG,
    [ViewType.PROJECT_SUMMARY]                  : PROJECT_SUMMARY_CONFIG,
    [ViewType.PROJECT_TABLE_MAP]                : PROJECT_TABLE_MAP_CONFIG,
    [ViewType.PROJECT_TODOS]                     : PROJECT_TODOS_CONFIG,

    [ViewType.PROJECTS_PORTFOLIO]               : PROJECTS_PORTFOLIO_CONFIG,




    /**---- MY WORK ----**/
    [ViewType.MY_RECENT]                        : MY_RECENT_CONFIG,
    [ViewType.MY_TASKS_LIST]                    : MY_TASKS_LIST_CONFIG,
    [ViewType.MY_WORK_WORKLOAD]                 : MY_WORK_WORKLOAD_CONFIG,
    [ViewType.MY_WORK_CALENDAR]                 : MY_WORK_CALENDAR_CONFIG,
    [ViewType.MY_MEETINGS]                      : MY_MEETINGS_CONFIG,
    [ViewType.MY_TIME]                          : MY_TIME_CONFIG,
    [ViewType.MY_WORK]                          : MY_WORK_CONFIG,
    [ViewType.NOTIFICATIONS]                    : NOTIFICATIONS_CONFIG,
    [ViewType.MY_NOTES]                         : MY_NOTES_CONFIG,
    [ViewType.MY_DOCUMENTS]                     : MY_DOCUMENTS_CONFIG,
    [ViewType.MY_GOALS]                         : MY_GOALS_CONFIG,
    [ViewType.MY_ATTENDANCE]                    : MY_ATTENDANCE_CONFIG,

    /**---- CUSTOM VIEW ----**/
    [ViewType.CUSTOM_VIEW_TASKS_TABLE]          : CUSTOM_VIEW_TASKS_TABLE_CONFIG,
    [ViewType.CUSTOM_VIEW_PROJECTS_TABLE]       : CUSTOM_VIEW_PROJECTS_TABLE_CONFIG,
    [ViewType.CUSTOM_VIEW_ACTIVITY]             : CUSTOM_VIEW_ACTIVITY_CONFIG,
    [ViewType.CUSTOM_VIEW_DOCUMENTS]            : CUSTOM_VIEW_DOCUMENTS_CONFIG,
    [ViewType.CUSTOM_VIEW_DASHBOARD]            : CUSTOM_VIEW_DASHBOARD_CONFIG,
    [ViewType.CUSTOM_VIEW_ACTION_REQUIRED]      : CUSTOM_VIEW_ACTION_REQUIRED_CONFIG,
    [ViewType.CUSTOM_VIEW_PRIORITIES]           : CUSTOM_VIEW_PRIORITIES_CONFIG,
    [ViewType.CUSTOM_VIEW_TASKS_BY_USER]        : CUSTOM_VIEW_TASKS_BY_USER_CONFIG,
    [ViewType.CUSTOM_VIEW_EVENTS_SUMMARY]       : CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG,
    [ViewType.CUSTOM_VIEW_WHATS_DONE]           : CUSTOM_VIEW_WHATS_DONE_CONFIG,
    [ViewType.CUSTOM_VIEW_PASTDUE]              : CUSTOM_VIEW_PASTDUE_CONFIG,
    [ViewType.CUSTOM_VIEW_EXPENSES]             : CUSTOM_VIEW_EXPENSES_CONFIG,
    [ViewType.CUSTOM_VIEW_CUSTOM_ENTITY_GLIST]  : CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG,


    /**---- PORTFOLIO ----**/
    [ViewType.PORTFOLIO_SUMMARY]                : PORTFOLIO_SUMMARY_CONFIG,
    [ViewType.PORTFOLIO_LIST]                   : PORTFOLIO_LIST_CONFIG,
    [ViewType.PORTFOLIO_TABLE]                  : PORTFOLIO_TABLE_CONFIG,
    [ViewType.PORTFOLIO_BOARD]                  : PORTFOLIO_BOARD_CONFIG,
    [ViewType.PORTFOLIO_GANTT]                  : PORTFOLIO_GANTT_CONFIG,
    [ViewType.PORTFOLIO_INFO]                   : PORTFOLIO_INFO_CONFIG,
    [ViewType.PORTFOLIO_CALENDAR]               : PORTFOLIO_CALENDAR_CONFIG,
    [ViewType.PORTFOLIO_WORKLOAD]               : PORTFOLIO_WORKLOAD_CONFIG,

    /**---- OLD ----**/
    [ViewType.RESOURCE_PLANNING]                : RESOURCE_PLANNING_CONFIG,
}

export const ViewTypeOldConvert : { [key: string]: ViewType } = {

    // THIS IS FOR OLD FORMAT USAGE
    'tasks_list'    : ViewType.PROJECT_LIST,
    'tasks_table'   : ViewType.PROJECT_TABLE,
    'board'         : ViewType.PROJECT_BOARD,
    'gantt'         : ViewType.PROJECT_GANTT,
    'summary'       : ViewType.PROJECT_INFO,
    'calendar'      : ViewType.PROJECT_CALENDAR,
    'files'         : ViewType.PROJECT_FILES,
    'activity'      : ViewType.PROJECT_ACTIVITY,
    'timeline'      : ViewType.PROJECT_WORKLOAD,
    'notes'         : ViewType.PROJECT_DOCS,
}
